import * as React from 'react'
import Milliseconds from '../../../helper/milliseconds'
import LargeNumber from '../../../helper/large-number'

interface Props {
    message?: {
        args: {
            calls: {
                [call: string]: {
                    ct: number
                    wt: number
                }
            }
        }
    }
}

export default class CommerceAdobeIo extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = <p></p>

        if (message) {
            const { args } = message

            intro = (
                <ul>
                    {Object.entries(args.calls).map(([call, stats]) => (
                        <li key={call}>
                            {call} - <Milliseconds value={stats.wt} /> (<LargeNumber value={stats.ct} useUnitClass={false} /> calls)
                        </li>
                    ))}
                </ul>
            )
        }

        return (
            <div>
                <p>No HTTP calls to commerce.adobe.io or commerce-beta.adobe.io should be made on product detail or category pages.</p>
                {intro}
            </div>
        )
    }
}
